module.exports = __webpack_public_path__ + "static/media/superior.d70ea5c0.webp";